import { Container, Row, Col } from 'react-bootstrap';
import SiteHeader from './SiteHeader';
import EPK from './EPK';
import Footer from './Footer';
import { useImageSrc, useSite } from './content/context';
import { themeStyle } from './theme/theme';
import { NewsletterPopup } from './sections/Newsletter';
import './theme/fonts';
import './theme/site.css';

/** The full public page. The admin editor renders this same component in edit mode. */
function SitePage() {
  const { data } = useSite();
  const imageSrc = useImageSrc();
  const theme = data.layout.theme;

  return (
    <div className="af-site" style={themeStyle(theme, imageSrc(theme.backgroundImage))}>
      <SiteHeader />
      <Container fluid className="af-page">
        <EPK />
      </Container>
      <Footer />
      <Row className="justify-content-center af-footer mx-0">
        <Col xs="auto">
          <p className="mb-0">&copy; {new Date().getFullYear()} Arc Flash. All Rights Reserved.</p>
        </Col>
      </Row>
      <NewsletterPopup />
    </div>
  );
}

export default SitePage;
